import { Container, useTheme } from "@mui/material"
import EanCodeCard from "components/EanCodeCard"
import MappCodeCard from "components/MappCodeCard"
import ResponsiveBackground from "components/ResponsiveBackground"
import { observer } from "mobx-react"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { isDevEnv } from "utils/env"
import { isMobile } from "utils/Global"
import { scrolltToTop } from "utils/util"
import { useTecDocStore } from "../../api/services/TecDoc"

// use this namespace also for subcomponents and for smaller subpages
export const namespace = __filename

const StartScreen = () => {
  const theme = useTheme()
  const tecDocStore = useTecDocStore()
  const history = useHistory()

  useEffect(() => {
    const initializeSession = () => {
      tecDocStore.reset()
      sessionStorage.clear()

      const paramGtin = "gtin"
      const paramCode = "code"

      const getURLParams = () => {
        return !isDevEnv() && document.referrer
          ? new URLSearchParams(new URL(document.referrer).search)
          : new URL(window.location.href).searchParams
      }

      const queryParams = getURLParams()
      const gtin = queryParams.get(paramGtin)
      const code = queryParams.get(paramCode)

      if (gtin && code) {
        sessionStorage.setItem("gtin", gtin)
        sessionStorage.setItem("code", code)
        history.push("/authenticity")
      }

      scrolltToTop()
      sessionStorage.removeItem("productCode")
      sessionStorage.setItem("vasImage", null)
    }

    initializeSession()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tecDocStore])

  return (
    <ResponsiveBackground theme={theme}>
      <Container
        sx={{
          display: "flex",
          height: isMobile ? "auto" : "100%",
          paddingX: isMobile ? 0 : 2,
          gap: "27px",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <MappCodeCard />
        <EanCodeCard />
      </Container>
    </ResponsiveBackground>
  )
}

export default observer(StartScreen)
